<template>
  <div class="PaidMemberRegistrationFinish">
    <div v-if="isSuccess || isUpdate">
      <section-header heading="2" ja="有料会員登録に成功しました" />
      <div class="description">有料会員登録の決済手続きが完了しました。</div>
      <sub-btn @click="onHome">ホームへ戻る</sub-btn>
    </div>
    <div v-else-if="isConsistency">
      <section-header heading="2" ja="WEB決済での会員状態を更新しました" />
        <div class="description">プロフィール設定から会員状態を確認してください。</div>
      <sub-btn @click="onSetting">プロフィール設定</sub-btn>
    </div>
    <div v-else>
      <section-header heading="2" ja="有料会員登録に失敗しました" />
      <div class="description">
        決済処理で何らかの問題が発生したため有料会員登録できませんでした。<br>
        <br>
        入力や操作に問題がない場合は、ご利用の携帯会社、またはクレジットカード会社にお問い合わせください。
      </div>
      <sub-btn @click="onHome">ホームへ戻る</sub-btn>
    </div>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import Protobuf from "../mixins/protobuf"
import SubBtn from '../components/SubBtn.vue'

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "PaidMemberRegistrationFinish",
  components: { SectionHeader, SubBtn },
  mixins: [ Protobuf ],
  computed: {
    isSuccess() {
      return this.$route.path === '/paidMemberRegistrationSuccess'
    },
    isUpdate() {
      return this.$route.path === '/paidMemberRegistrationUpdate'
    },
    isConsistency() {
      return this.$route.path === '/paidMemberRegistrationConsistency'
    }
  },
  methods: {
    onHome() {
      this.$router.push('/')
    },
    onSetting() {
      this.$router.push('/setting')
    },
    requestResult() {
      const cmdNo = pb.BuyMembershipResultReq.CommandNo.COMMAND_NO
      const message = pb.BuyMembershipResultReq.create()
      const encoded = pb.BuyMembershipResultReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          this.$store.dispatch('saveMembershipGrade', decoded.membershipGrade)
          this.$store.dispatch('saveRegistrationType', pb.LoginResp.RegistrationType.WEB_REGIST)
        })
        .catch(() => {
          this.$_error('Error', { title: '有料会員を登録を完了しました', statusCode: 100 })
        })
    },
    requestUpdate() {
      const cmdNo = pb.BuyMembershipUpdateReq.CommandNo.COMMAND_NO
      const message = pb.BuyMembershipUpdateReq.create()
      const encoded = pb.BuyMembershipUpdateReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          // レシートチェック状態 -2:ゲームサーバー側エラー -1:未処理 0:処理完了 1以上:レシートチェック側エラー
          if (decoded.receiptStatus === 0) {
            this.$store.dispatch('saveMembershipGrade', decoded.membershipGrade)
            this.$store.dispatch('saveRegistrationType', pb.LoginResp.RegistrationType.WEB_REGIST)
          } else if (decoded.receiptStatus === -1) {
            this.reRequestUpdate()
          } else {
            this.$_error('Error', { title: '有料会員を登録を完了しました', statusCode: 100 })
          }
      })
        .catch(() => {
          this.$_error('Error', { title: '有料会員を登録を完了しました', statusCode: 100 })
        })
    },
    reRequestUpdate() {
      this.$store.state.isConnecting = true
      setInterval(() => {
        this.$store.state.isConnecting = false
        this.requestUpdate()
      }, 1000);
    }
  },
  mounted() {
    if (this.isSuccess || this.isConsistency) {
      this.requestResult()
    } else if (this.isUpdate) {
      this.requestUpdate()
    }
  }
}
</script>

<style scoped>
.description {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
</style>
